import Swiper from 'swiper/bundle';
import {each} from 'lodash';
import { media, media_expression } from '../../utils/media';
export default class ContentHub{
    constructor(){
        this.hub = {
            section: document.querySelector('section.content-hub'),
            container: document.querySelector('section.content-hub .carousel'),
            grid: document.querySelector('section.content-hub .article-grid'),
            articles: document.querySelectorAll('section.content-hub article.tease'),
            // ctas: document.querySelector('section.content-hub [data-cta]'),
        }

        this.carousel = {
            init: false,
            object: undefined,
            element: document.querySelector('.carousel[data-carousel="only-mobile"]'),
        }

        this.cloned = {
            ctas: undefined,
        }
        
        if(this.hub.articles.length > 4){
            this.createCarousel(this.carousel.element); // Init Carousel
            window.addEventListener('resize', this.onResize);
        }
    }
    

    createCarousel(target){
        if(media('<Laptop')) {
            // console.log('<=Laptop', media('<=Laptop'))

            if(!this.cloned.ctas){
                // this.cloned.ctas = this.hub.ctas.cloneNode(true);
                // this.hub.section.append(this.cloned.ctas);
                // this.hub.ctas.remove();
            }

            if (!this.carousel.init) {
                this.carousel.init = true;

                this.carousel.object = new Swiper(this.carousel.element, {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    // loop: true,
                    // centeredSlides: true,
                    navigation: {
                        // nextEl: this.cloned.ctas.querySelector('.btn-arrow.next'),
                        // prevEl: this.cloned.ctas.querySelector('.btn-arrow.prev'),
                    },
                });
                
            }
        } else if(media('>=Laptop')) {
            // console.log('>Laptop', media('>Laptop'))

            this.carousel.init = false;
            if(this.carousel.object) { 
                this.carousel.object.destroy() 
            }

            if(this.cloned.ctas){ 
                this.hub.section.querySelector('[data-cta]').remove()
                this.hub.grid.append(this.cloned.ctas)
                // this.hub.ctas = document.querySelector('section.content-hub [data-cta]')
                // this.cloned.ctas = undefined
            }
        }
    }

    onResize = () => {
        // console.log(window.innerWidth, media_expression('>=Laptop'))
        this.createCarousel(this.carousel.element);
    }
}